export function isShopItemOutOfStock(item) {
  if (!item) return false;
  const count = item.currentStock ?? 0;
  if (item.stockStatus === 'out') return true;
  if (item.isAvailable === false) return true;
  return count <= 0;
}

export function getGalleryStockLabel(item, t) {
  const count = item.currentStock ?? 0;
  if (isShopItemOutOfStock(item)) {
    return t('gallery.stockOutOfStock');
  }
  const isLow = item.stockStatus === 'low' || count <= 5;
  return isLow
    ? t('gallery.stockLow', { count })
    : t('gallery.stockInStock', { count });
}
